import { createFileRoute } from "@tanstack/react-router";
import InvoiceItems from "@/components/InvoiceItems";

function RouteComponent() {
  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-xl sm:text-2xl font-semibold">Invoice Items</h1>
        <p className="text-sm text-muted-foreground">Manage invoice line item catalog.</p>
      </div>
      <InvoiceItems />
    </div>
  );
}

export const Route = createFileRoute("/_authenticated/invoice-items/")({
  component: RouteComponent,
  staticData: { page: "finance" },
});
